module.exports = __webpack_public_path__ + "media/images/logo-580d7c11f22cbeafc23f3e5154642ba7.png";